import React from "react";
import s from "./s.module.scss";
import { useHistory } from "react-router-dom";
import { InputNumberProps } from "antd/lib/input-number";
import { InputNumber, Input } from "antd";

type Props = InputNumberProps & {};

function NumberInput(props: Props) {
  const [val, setVal] = React.useState<number | undefined | null>(1);

  const onChange = (value: number | undefined | null) => {
    setVal(value);
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <div className={s.wrap}>
      <span
        className={s.minus}
        onClick={() => {
          let newVal = val ? val - 1 : 0;
          if (newVal < 1) {
            newVal = 1;
          }
          onChange(newVal);
        }}
      >
        -
      </span>
      <InputNumber
        {...props}
        onChange={onChange}
        value={val && val !== 0 ? val : undefined}
      />
      <span
        className={s.add}
        onClick={() => {
          onChange(val ? val + 1 : 1);
        }}
      >
        +
      </span>
    </div>
  );
}

export default NumberInput;
